module.exports = __webpack_public_path__ + "static/media/thum_5.db9a135c.jpg";